import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ServicePage from "../pages/services/page";
import PortfolioPage from "../pages/portfolio/page";
import PortfolioDetailPage from "../pages/portfolio-detail/page";
import BlogDetailPage from "../pages/blog-detail/page";
import LocationSuratPage from "../pages/location-surat/page";
import LocationSFPage from "../pages/location-san-francisco/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services/:slug",
    element: <ServicePage />,
  },
  {
    path: "/portfolio",
    element: <PortfolioPage />,
  },
  {
    path: "/portfolio/:slug",
    element: <PortfolioDetailPage />,
  },
  {
    path: "/blog/:slug",
    element: <BlogDetailPage />,
  },
  {
    path: "/surat",
    element: <LocationSuratPage />,
  },
  {
    path: "/san-francisco",
    element: <LocationSFPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
